import React from 'react';  // eslint-disable-line

const Profile = (props) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zm0-4.727c-1.607 0-2.91-1.666-2.91-3.273V7.545a2.91 2.91 0 0 1 5.818 0L11.91 9c0 1.607-1.302 3.273-2.909 3.273zm-1.82-.783l-2.171 1.245a2.182 2.182 0 0 0-1.1 1.895v.541m10.182 0v-.541c0-.783-.42-1.506-1.1-1.894l-2.17-1.246" stroke={props.activeColor} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default Profile;
